var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDivyLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    id: "split",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60 22.42V11a7.008 7.008 0 0 0-7-7H11a7.008 7.008 0 0 0-7 7v11.42a1 1 0 0 0 2 0V11a5.006 5.006 0 0 1 5-5h20v52H11a5.006 5.006 0 0 1-5-5V41.58a1 1 0 0 0-2 0V53a7.008 7.008 0 0 0 7 7h42a7.008 7.008 0 0 0 7-7V41.58a1 1 0 0 0-2 0V53a5.006 5.006 0 0 1-5 5H33V6h20a5.006 5.006 0 0 1 5 5v11.42a1 1 0 1 0 2 0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.818 22.49a1 1 0 1 0-1.414-1.415l-7.81 7.81a4.41 4.41 0 0 0 0 6.23l7.81 7.81a1 1 0 1 0 1.414-1.414l-7.81-7.81A2.38 2.38 0 0 1 7.532 33h20.348a1 1 0 1 0 0-2H7.53a2.38 2.38 0 0 1 .478-.701zm32.364 19.02a1 1 0 1 0 1.414 1.415l7.81-7.81a4.41 4.41 0 0 0 0-6.23l-7.81-7.81a1 1 0 0 0-1.414 1.414l7.81 7.81a2.38 2.38 0 0 1 .477.701H36.121a1 1 0 0 0 0 2H56.47a2.38 2.38 0 0 1-.478.701z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDivyLogo);
export default __webpack_public_path__ + "static/media/divy-logo.77024cbb4d8a05bccd3d069e78e0d4e2.svg";
export { ForwardRef as ReactComponent };